export default {
    data() {
        return {
            currentFolder: null,
            tree: null
        }
    },
    props: {
        show: {
            type: Boolean,
            value: false
        }
    },
    mounted: function () {
        this.query();
    },
    methods: {
        /**
         * 左侧承包商类型点击
         * @param {*} node 
         * @param {*} nodeObj 
         * @param {*} comp 
         */
        treeClick: function (node, nodeObj, comp) {
            this.currentFolder = node;
        },
        /**
         * 关闭弹框
         */
        handleClose: function () {
            this.$emit("onClose", false);
        },
        /**
         * 点击确定
         */
        confirm: function () {
            if (this.currentFolder == null) {
                this.$message.closeAll();
                this.$message.warning("请选择文件夹");
                return;
            }
            this.$emit("callback", this.currentFolder);
        },
        /**
         * 递归构造tree数据
         * @param {*} data 
         */
        toTree: function (data) {
            data.forEach(function (item) {
                delete item.children;
            });

            var map = {};
            data.forEach(function (item) {
                map[item.id] = item;
            });
            var val = [];
            data.forEach(function (item) {
                // 以当前遍历项，的parentId,去map对象中找到索引的id
                var parent = map[item.parentId];
                if (parent) {
                    (parent.children || (parent.children = [])).push(item);
                } else {
                    val.push(item);
                }
            });
            return val;
        },
        /**
         * 查询全部文件夹
         */
        query: function () {
            this.$post({
                url: "/folder/queryAll",
                params: {}
            }).then(response => {
                this.tree = this.toTree(response);
            });
        }
    }
}